<script lang="ts">
    import { Subhead, DropdownShell, Dropdown, Button } from "attractions";
    import Fa from "svelte-fa";
    import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

    export let people;
    export let onPeopleChange: (nextPeople: number) => void;

    const peopleOptions = [2, 3, 4, 5, 6, 7, 8, 9, 10];
</script>

<div class="root-container">
    <div class="margin-bottom-sm">
        <Subhead>How many people?</Subhead>
    </div>
    <DropdownShell let:toggle>
        <Button on:click={toggle}>
            <div class="btn-content-container">
                {people}
                <div class="margin-left-md">
                    <Fa icon={faChevronDown} />
                </div>
            </div>
        </Button>
        <Dropdown>
            <div class="dropdown-container">
                {#each peopleOptions as peopleOption}
                    <Button
                        on:click={() => {
                            toggle();
                            if (people !== peopleOption) {
                                people = peopleOption;
                                onPeopleChange(people);
                            }
                        }}
                    >
                        <span class="margin-left-sm margin-right-sm"
                            >{peopleOption}</span
                        >
                    </Button>
                {/each}
            </div>
        </Dropdown>
    </DropdownShell>
</div>

<style lang="scss">
    @use "common.scss";
    @import "theme.scss";

    .root-container {
        width: 440px;
        height: 200px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .dropdown-container {
        max-height: 200px;
        overflow-y: auto;
    }

    .btn-icon {
        margin-left: 2rem;
    }

    .btn-content-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
</style>
